// extracted by mini-css-extract-plugin
export default {"addRoleForm":"styles_addRoleForm__iWA2q","buttonsGroup":"styles_buttonsGroup__6rpuL"};